module.exports = __webpack_public_path__ + "static/media/DefNot.ee08a03b.png";